import { inject, Injectable } from '@angular/core';
import { ApiService } from '@capturum/api';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable, tap } from 'rxjs';
import { RoleService } from './role.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService extends ApiService<string[]> {
  private roleService = inject(RoleService);
  private ngxPermissionsService = inject(NgxPermissionsService);

  public loadPermissions(): Observable<string[]> {
    return this.roleService.getUserRolePermissions().pipe(
      tap((permissions) => {
        this.ngxPermissionsService.loadPermissions(permissions);
      }),
    );
  }
}
